<template>
  <div class="boss-main-wrap boss-main-content-wrap">
    <div class="grid-x hide-for-print">
      <div class="cell auto pega-usage-notes">
        <job-preview-provision-list-link class="pega-accordion-link-header" />
      </div>
      <print-button class="cell shrink" />
    </div>
    <div
      data-test="button-area"
      class="grid-x margin-bottom-1 hide-for-print"
    >
      <div class="cell">
        <!-- メッセージ位置までジャンプするボタン offsetはヘッダ分 -->
        <button
          v-if="showApprovalCreateArea"
          v-scroll-to="{ el: '#message', offset: -35 }"
          class="boss-button-center boss-icon-message pega-preview-jump-button pega-blue-button"
          data-test="message-jump"
        >
          企業担当者とのメッセージはこちら
        </button>
      </div>
    </div>
    <template v-if="clientJobEdit">
      <preview-job
        :is-show-comment="false"
        :is-show-text-count="true"
        :is-client-job="true"
        :job-info="jobInfo"
        :company-interview="companyInterview"
        :company-info="companyInfo"
        :about-apply="aboutApply"
      />
      <preview-code-setting
        :is-show-comment="false"
        :is-client-job="true"
        :code-setting="codeSetting"
        :official-company-name="''"
        :display-company-name="''"
        :company-name-kana="''"
        :is-not-output-google-for-jobs="false"
      />
    </template>
    <!-- メッセージ作成 -->
    <div>
      <job-edit-examination-approval-create
        v-if="showApprovalCreateArea"
        id="message"
        v-model="messageBody"
        :is-over-length="isOverLengthBody"
        :max-message-body="maxMessageBody"
        :has-approval-permission="hasApprovalPermission"
        @approve="onApproved"
        @reject="onRejected"
      />
    </div>
    <!-- メッセージ履歴 -->
    <div class="pega-preview">
      <client-job-edit-preview-message-sent-history
        :messages="messages"
        class="margin-bottom-3"
      />
    </div>
  </div>
</template>

<script>
import PrintButton from '@/components/atoms/PrintButton'
import JobPreviewProvisionListLink from '@/components/atoms/JobPreviewProvisionListLink'
import PreviewJob from '@/components/organisms/PreviewJob'
import PreviewCodeSetting from '@/components/organisms/PreviewCodeSetting'
import * as clientJobConverter from '@/lib/clientJob/clientJobConverter'
import JobEditExaminationApprovalCreate from '@/components/molecules/JobEditExaminationApprovalCreate'
import ClientJobEditPreviewMessageSentHistory from '@/components/organisms/ClientJobEditPreviewMessageSentHistory'
import { getClientJobEditStatusUiVariation } from '@/lib/uiVariationMapping.js'
import util from '@/lib/util'

export default {
  components: {
    PrintButton,
    JobPreviewProvisionListLink,
    PreviewJob,
    PreviewCodeSetting,
    JobEditExaminationApprovalCreate,
    ClientJobEditPreviewMessageSentHistory
  },
  data () {
    return {
      clientJobEdit: null,
      messages: [],
      messageBody: '',
      isFinishCreated: false,
      hasApprovalPermission: false,
      folderChildId: null
    }
  },
  computed: {
    companyId () {
      return this.$route.params.companyId
    },
    jobEditId () {
      return this.$route.params.jobEditId
    },
    maxMessageBody: () => 2000,
    jobInfo () {
      return clientJobConverter.toJobInfo(this.clientJobEdit)
    },
    companyInterview () {
      return clientJobConverter.defaultCompanyInterview
    },
    companyInfo () {
      return clientJobConverter.toCompanyInfo(this.clientJobEdit)
    },
    aboutApply () {
      return clientJobConverter.toAboutApply(this.clientJobEdit)
    },
    codeSetting () {
      return clientJobConverter.toCodeSetting(this.clientJobEdit)
    },
    isOverLengthBody () {
      return this.messageBody.length > this.maxMessageBody
    },
    statusCode () {
      return this.clientJobEdit ? (this.clientJobEdit.currentExaminationStatusCode ?? '') : ''
    },
    uiVariation () {
      return getClientJobEditStatusUiVariation(this.statusCode)
    },
    showApprovalCreateArea () {
      return this.isFinishCreated && this.uiVariation.showApprovalArea
    }
  },
  created () {
    this.callApis()
  },
  methods: {
    callApis () {
      Promise.all([
        this.$http.secured.get(`/preview/edit/companies/${this.companyId}/client/jobs/${this.jobEditId}/approval`),
        this.$http.secured.get(`/preview/edit/companies/${this.companyId}/client/jobs/${this.jobEditId}/approval/messages`),
        this.$http.secured.get(`/preview/edit/companies/${this.companyId}/client/jobs/${this.jobEditId}/examination/has_approval_permission`),
        this.$http.secured.get(`/preview/companies/${this.companyId}/publishing_folder_child`)
      ]).then(([clientJobEditResponse, messagesResponse, hasApprovalPermissionResponse, publishingFolderChildResponse]) => {
        this.$set(this, 'clientJobEdit', clientJobEditResponse.data)
        this.$set(this, 'messages', messagesResponse.data)
        this.$set(this, 'hasApprovalPermission', hasApprovalPermissionResponse.data)
        // 承認プレビューを開いた時点の掲載期間内子フォルダIDを保持し、承認実行時に付与する
        this.$set(this, 'folderChildId', publishingFolderChildResponse.data.folderChildId)
        this.isFinishCreated = true
      })
    },
    onApproved () {
      this.$dialog.confirm('承認してよろしいですか？<br>（メッセージがある場合は同時に送信されます）')
        .then(() => {
          const query = this.folderChildId ? `?folderChildId=${this.folderChildId}` : ''
          this.$http.secured.put(
            `/preview/edit/companies/${this.companyId}/client/jobs/${this.jobEditId}/examination/_approve${query}`,
            { statusUpdateAt: this.clientJobEdit.statusUpdatedAt, message: this.messageBody || null }
          ).then(() => {
            this.$toasted.global.success({ message: '承認しました' })
            util.closeAndReloadOpener(window)
          }).catch(() => {})
        })
        // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    },
    onRejected () {
      this.$dialog.confirm('不承認でメッセージを送信してよろしいですか？')
        .then(() => {
          this.$http.secured.put(
            `/preview/edit/companies/${this.companyId}/client/jobs/${this.jobEditId}/examination/_reject`,
            { statusUpdateAt: this.clientJobEdit.statusUpdatedAt, message: this.messageBody }
          ).then(() => {
            this.$toasted.global.success({ message: '不承認にしました' })
            util.closeAndReloadOpener(window)
          }).catch(() => {})
        })
        // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    }
  }
}
</script>
